import { formatMoney } from '@/utils'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './SaldoAntecipado.scss'

interface Props {
    disponivel: number
    to: string
}

export default function SaldoAntecipadoResumoCard({ disponivel, to }: Props) {
    const { t } = useTranslation()

    return (
        <Link to={to} className="saldo-antecipado-resumo">
            <div className="saldo-antecipado-resumo-text">
                <h2 className="saldo-antecipado-resumo-title">{t('Saldo Antecipado')}</h2>
                <span className="saldo-antecipado-resumo-label">{t('Saldo Disponível')}</span>
                <strong className="saldo-antecipado-resumo-valor">{formatMoney(disponivel)}</strong>
            </div>
            <span className="saldo-antecipado-resumo-action">
                {t('Ver extrato')}
                <span aria-hidden="true">›</span>
            </span>
        </Link>
    )
}
